// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"60":"226715fe7b5259c94f47","117":"11577875ad99bb812af9","232":"2fb6a1b01eb2b86b0915","802":"8fc53573feabcc2408c3","817":"ce444010979a2d046976","833":"9ac641b1a9e6859f324b"}[chunkId] + ".js";
};